import { createAction, handleActions } from 'redux-actions';

const defaultState = {
  canvasId: null,
  initializationStatus: 'idle',
};

const prefix = 'APP_';
export const setCanvasId = createAction(`${prefix}SET_CANVAS_ID`);
export const setInitializationStatus = createAction(`${prefix}SET_INITIALIZATION_STATUS`);

const reducer = handleActions(
  {
    [setCanvasId]: (state, action) => ({ ...state, canvasId: action.payload }),
    [setInitializationStatus]: (state, action) => ({ ...state, initializationStatus: action.payload }),
  },
  defaultState,
);

export default reducer;
